export default "__VITE_ASSET__1e992a6e__"